window.GE = window.GE || {};
window.GE.impressedProducts = {};
window.GE.trackProductImpressions = function () {
    if (this.trackingProductsNow) {
        return false;
    }

    this.trackingProductsNow = true;

    const set = [];

    document.querySelectorAll(".ge-card").forEach((el, idx) => {
        const id = el.dataset.itemId;
        if (window.GE.impressedProducts[id]) {
            return;
        }

        if (window.GE.isElementInViewport(el)) {
            set.push({
                id: el.dataset.itemId,
                name: el.dataset.itemName,
                price: el.dataset.itemPrice,
                list: el.dataset.itemList,
                position: idx + 1,
            });
        }
    });

    this.trackingProductsNow = false;

    for (let i = 0; i < set.length; i++) {
        this.impressedProducts[set[i].id] = set[i];
    }

    if (set.length) {
        try {
            window.GE.callbacks?.modelsViewed?.(set);
        } catch (e) {
            console.error(e);
        }
    }
};
window.GE.isElementInViewport = function (el) {
    if (!el) return false;

    const rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

(function () {
    const main = document.querySelector('main');
    if (!main) return;

    main.addEventListener('click', function (e) {
        const card = e.target.closest('.ge-card');

        if (!card || !main.contains(card)) return;
        const link = e.target.closest('a');
        if (!link) return;

        const item = {
            id: card.dataset.itemId,
            name: card.dataset.itemName,
            price: card.dataset.itemPrice,
            category: card.dataset.itemCategory,
        };
        try {
            window.GE.callbacks?.modelClicked?.(item, card.dataset.itemList);
        } catch (err) {
            console.error(err);
        }
    });
})();
['DOMContentLoaded', 'load', 'resize', 'scroll'].forEach(event => {
    window.addEventListener(event, () => {
        window.GE.trackProductImpressions();
    });
});
